import { createIcon } from '@chakra-ui/icons';

export const Docx = createIcon({
  displayName: 'Docx',
  viewBox: '0 0 16 16',
  path: [
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.64207 10.9886C9.46333 11.2244 9.33333 11.5797 9.33333 12C9.33333 12.4203 9.46333 12.7756 9.64207 13.0114C9.82053 13.2467 10.0183 13.3333 10.1833 13.3333C10.2547 13.3333 10.3255 13.3183 10.3966 13.2868L11.0061 13.0167L11.5463 14.2358L10.9367 14.5058C10.7042 14.6089 10.4499 14.6667 10.1833 14.6667C9.5108 14.6667 8.95013 14.3056 8.57967 13.8171C8.20953 13.3289 8 12.6843 8 12C8 11.3157 8.20953 10.6711 8.57967 10.1829C8.95013 9.69441 9.5108 9.33334 10.1833 9.33334C10.4499 9.33334 10.7042 9.39114 10.9367 9.49421L11.5463 9.76421L11.0061 10.9833L10.3966 10.7132C10.3255 10.6817 10.2547 10.6667 10.1833 10.6667C10.0183 10.6667 9.82053 10.7533 9.64207 10.9886Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.33334H1C2.47276 9.33334 3.66667 10.5273 3.66667 12C3.66667 13.4727 2.47276 14.6667 1 14.6667H0V9.33334ZM1.33333 10.7087V13.2913C1.90841 13.1433 2.33333 12.6213 2.33333 12C2.33333 11.3787 1.90841 10.8567 1.33333 10.7087Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.30609 10.9858C5.1292 11.2217 5.00008 11.578 5.00008 12C5.00008 12.422 5.1292 12.7783 5.30609 13.0142C5.48282 13.2499 5.67609 13.3333 5.83341 13.3333C5.99074 13.3333 6.18401 13.2499 6.36074 13.0142C6.53763 12.7783 6.66675 12.422 6.66675 12C6.66675 11.578 6.53763 11.2217 6.36074 10.9858C6.18401 10.7501 5.99074 10.6667 5.83341 10.6667C5.67609 10.6667 5.48282 10.7501 5.30609 10.9858ZM4.23942 10.1858C4.60558 9.69761 5.16231 9.33334 5.83341 9.33334C6.50451 9.33334 7.06128 9.69761 7.42741 10.1858C7.79341 10.6738 8.00008 11.3174 8.00008 12C8.00008 12.6826 7.79341 13.3262 7.42741 13.8142C7.06128 14.3024 6.50451 14.6667 5.83341 14.6667C5.16231 14.6667 4.60558 14.3024 4.23942 13.8142C3.87341 13.3262 3.66675 12.6826 3.66675 12C3.66675 11.3174 3.87341 10.6738 4.23942 10.1858Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5105 9.33334H13.3333V9.87461L15.9828 14.6667H14.1604V14.1263L11.5105 9.33334Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9843 9.33334H14.1669V9.87541L11.5413 14.6667H13.3593V14.1237L15.9843 9.33334Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.3856 0.666672C6.8552 0.666672 6.34648 0.877385 5.97141 1.25246L2.58579 4.63808C2.21071 5.01315 2 5.52186 2 6.05229V8.00001H14V2.66667C14 1.56211 13.1046 0.666672 12 0.666672H7.3856ZM7.33333 6.00001H3.33333L7.33333 2.00001V6.00001Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
